import {Component, OnInit, OnDestroy} from "@angular/core";
import {MessagesSettings} from "./components/messages.settings";
import {MessageCollection, MessageCollectionRespone} from "../shared/api/messages/api.models";
import {Observable} from "rxjs/Observable";
import {Api} from "../shared/api.service";
import {AuthenticationService} from "../shared/authentication.service";

@Component({
    selector : 'check-message',
    template: require('./check.component.html')
})

export class CheckMessageComponent implements OnInit, OnDestroy {
    private searchIteration           : number  = 0;
    private searchIterationCurveIndex : number  = 75;
    private searchCooldownTimeout;
    private searchCooldownMin         : number  = 3000;
    private searchCooldownMax         : number  = 30000;

    protected settings          : MessagesSettings;
    protected messageCollection : MessageCollection;
    protected searching         : boolean = false;

    constructor(private api: Api, private auth: AuthenticationService) {}

    ngOnInit(): void {
        this.settings              = new MessagesSettings();
        this.settings.approvalMode = true;
        this.settings.startScreen  = MessagesSettings.SCREEN_PROPERTIES;

        this.startSearching();
    }

    ngOnDestroy(): void {
        if (this.searchCooldownTimeout) {
            window.clearTimeout(this.searchCooldownTimeout);
        }
    }

    saved() {
        this.startSearching();
    }

    reload() {
        this.searching         = true;
        let id                 = this.messageCollection.id;
        this.messageCollection = null;

        this.api.messages().resource(id).subscribe(
            (messageCollection: MessageCollection) => {
                this.messageCollection = messageCollection;
                this.searching         = false;
            },
            () => {
                this.startSearching();
            }
        )

    }

    private resetState(): void {
        this.messageCollection;
        this.searching       = false;
        this.searchIteration = 0;
    }

    private startSearching(reset: boolean = true) {
        if (reset === true) {
            this.resetState();
        }

        this.searching = true;

        let mainSubscription = Observable.create((mainObservable) => {
            let subscription = this.api.messages().collection(
                1,
                5,
                undefined,
                undefined,
                MessageCollection.STATUS_READY_FOR_APPROVAL,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                this.auth.getMe().preferences.languages,
                false,
                true
            ).subscribe(
                (response: MessageCollectionRespone) => {
                    subscription.unsubscribe();

                    if (response.result.length === 0) {
                        mainObservable.error();
                        return;
                    }

                    this.claimMessageCollection(response.result).subscribe(
                        (messageCollection: MessageCollection) => {
                            mainObservable.next(messageCollection);
                        },
                        () => {
                            mainObservable.error();
                        }
                    );
                },
                () => {
                    mainObservable.error();
                }
            );
        }).subscribe(
            (messageCollection: MessageCollection) => {
                mainSubscription.unsubscribe();

                this.searching         = false;
                this.messageCollection = messageCollection;
            },
            () => {
                mainSubscription.unsubscribe();

                let timeout = (Math.pow(this.searchIteration, 2) / this.searchIterationCurveIndex + 1) * this.searchCooldownMin;
                if (timeout > this.searchCooldownMax) {
                    timeout = this.searchCooldownMax;
                }

                timeout = Math.floor(timeout);
                this.searchIteration += 1;

                this.searchCooldownTimeout = window.setTimeout(() => this.startSearching(false), timeout);
            }
        );
    }

    private claimMessageCollection(messageCollections: MessageCollection[]) {

        let observable = Observable.create((childObservable) => {
            this.api.messages().lock(messageCollections[0].id).subscribe(
                () => {
                    this.api.messages().resource(messageCollections[0].id).subscribe(
                        (messageCollection: MessageCollection) => { // Fetched complete message collection
                            childObservable.next(messageCollection);
                        },
                        () => { // Could not fetch complete message collection
                            childObservable.error();
                        }
                    )
                },
                () => {
                    childObservable.error();
                }
            )
        });

        for (let i = 1; i < messageCollections.length ; i++) {
            observable = observable.onErrorResumeNext(Observable.create((childObservable) => {
                this.api.messages().lock(messageCollections[i].id).subscribe(
                    () => {
                        this.api.messages().resource(messageCollections[i].id).subscribe(
                            (messageCollection: MessageCollection) => { // Fetched complete message collection
                                childObservable.next(messageCollection);
                            },
                            () => { // Could not fetch complete message collection
                                childObservable.error();
                            }
                        )
                    },
                    () => {
                        childObservable.error();
                    }
                )
            }));
        }

        return observable;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/messages/check.component.ts